// extracted by mini-css-extract-plugin
export default {"warning":"warning---J6q8u","warningList":"warningList---JN_Xj"};